import ModerationListPage from './moderationListPage';

export default ModerationListPage;
